import styled from "styled-components";

export const Overlay = styled.div`
  @media screen and (max-width: 768px) {
    display: none;
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 30;
    background-color: #00000090;
    backdrop-filter: blur(10px);

    &.open {
      display: block;
    }
  }
`;

export const Wrapper = styled.div`
  padding-bottom: 4px;
  min-height: 100vh;
  width: 240px;
  position: fixed;
  top: 0;
  background: #021128;
  color: #fff;
  z-index: 12;

  .logo {
    padding: 12px 24px;
    display: flex;
    align-items: center;
    gap: 5.36px;
  }

  .top-section {
    height: calc(100vh - 360px);
    overflow-y: scroll;
    border-top: 1px solid rgba(204, 204, 204, 0.2);

    &::-webkit-scrollbar {
      width: 6px;
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      cursor: pointer;
      border-radius: 15px;
      background: rgba(204, 204, 204, 0.8);
    }
  }

  .image-with-dot {
    position: relative;

    .dot {
      position: absolute;
      z-index: 1;
      right: -3px;
      top: -3px;
      width: 6px;
      height: 6px;
      background: #fd0403;
      border-radius: 50%;
    }

    .green-dot {
      background: var(--success);
      width: 8px;
      height: 8px;
      right: 0;
      top: 0;
    }
  }

  .brands-header {
    font-weight: 450;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 1px;
  }

  @media screen and (max-width: 768px) {
    position: fixed;
    min-height: 100vh;
    left: -100%;
    top: 0;
    z-index: 40;
    transition: all 0.2s ease-out;

    &.open {
      width: 87%;
      left: 0;
    }
  }
`;

export const Brands = styled.div`
  padding: 12px 24px;
  position: sticky;
  top: 0;
  background-color: #021128;
  z-index: 3;

  .brands-dropdown {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    .brand-name-flex {
      max-width: 90%;
    }

    .brand-name {
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
    }
  }

  .close-icon {
    float: right;
    margin-top: -25px;
    display: none;
  }

  @media screen and (max-width: 768px) {
    .close-icon {
      display: block;
    }
  }
`;

export const ArrowWrapper = styled.button`
  width: 20px;
  height: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
    background: #031f48;
  }
`;

export const Menu = styled.div`
  margin: 12px 0 100px;
  color: #cccccc;
  padding: 0 12px;

  .icon {
    width: 16px;
    height: 16px;
  }

  li a,
  .linkGroupWrapper {
    padding: 12px 14px;
    border-radius: 6px;
    text-decoration: none;
    display: block;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
    color: #cccccc;
    margin-bottom: 5px;

    &:hover {
      background: rgba(3, 31, 72, 0.9);
      color: #fff;
      .icon {
        filter: brightness(150%);
      }
    }

    &:focus {
      outline: none;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }

  .linkGroup {
    display: flex;
    align-items: center;
    gap: 8px;

    &.coming-soon {
      gap: 0;

      .icon,
      .text {
        opacity: 0.3;
      }

      .text {
        white-space: nowrap;
        margin-left: 8px;
      }

      .tag {
        font-size: 8px;
        line-height: 12px;
        background-color: #ffe8d8;
        padding: 3px 6px;
        margin-left: 3px;
        white-space: nowrap;
        border-radius: 8px;
        color: var(--text);
      }
    }
  }

  .active {
    background: rgba(3, 31, 72, 0.9);
    color: #fff;
    font-weight: 700;

    .icon {
      filter: brightness(150%);
    }
  }

  .subLinks {
    padding-left: 24px;

    .active {
      background: transparent;
      color: var(--secondary);
    }
  }
`;

export const BottomSection = styled.div`
  position: absolute;
  height: 360px;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid rgba(204, 204, 204, 0.2);
  background-color: #021128;
  z-index: 3;
  padding-top: 2px;

  .workspace-header {
    padding-left: 24px;
    font-weight: 450;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 1px;
  }

  .workspace_acc + .workspace_acc {
    margin-left: -10px;
  }
`;

export const WorkspaceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-left: 24px;
  padding-right: 16px;
  cursor: pointer;
  border-top: 1px solid rgba(204, 204, 204, 0.2);
  position: relative;

  .workspace_name {
    overflow: hidden;
    color: rgba(204, 204, 204, 0.8);
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 450;
    line-height: 16px;
  }

  .arrow-icon {
    transform: rotate(270deg);
    width: 20px;
    height: 20px;
  }

  .wrapper {
    max-width: 25px;
  }

  .workspaces .wrapper:nth-child(2) {
    z-index: -1;
  }
  .workspaces .wrapper:nth-child(3) {
    z-index: -2;
  }
  .workspaces .wrapper:nth-child(4) {
    z-index: -3;
  }

  .workspaces .wrapper:nth-child(2) .imgWrapper {
    background: var(--secondary);
  }
  .workspaces .wrapper:nth-child(3) .imgWrapper {
    background: var(--warning);
  }
  .workspaces .wrapper:nth-child(4) .imgWrapper {
    background: var(--success);
  }

  .workspace {
    width: 32px;
    height: 32px;
    background: #032250;
    border-radius: 50%;
    font-weight: 450;
    font-size: 12px;
  }
`;

export const WorkspaceMenu = styled.div`
  padding: 0 12px;
  color: #cccccc;

  .icon {
    width: 16px;
    height: 16px;
  }

  .menu-list a,
  button {
    padding: 12px 14px;
    border-radius: 6px;
    text-decoration: none;
    display: block;
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
    color: #cccccc;
    margin-bottom: 3px;

    &:hover {
      background: rgba(3, 31, 72, 0.9);
      color: #fff;
      .icon {
        filter: brightness(150%);
      }
    }

    &:focus {
      outline: none;
    }
  }

  .linkGroup {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .active {
    background: rgba(3, 31, 72, 0.9);
    color: #fff;
    font-weight: 700 !important;
    .icon {
      filter: brightness(150%);
    }
  }
`;

export const MobileAppButton = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  margin: 0 12px 16px 12px;
  background: linear-gradient(
    135deg,
    var(--primary) 0%,
    var(--primary_light) 100%
  );
  border-radius: 10px;
  text-decoration: none;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(1, 87, 155, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.1),
      transparent
    );
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(1, 87, 155, 0.4);

    &::before {
      left: 100%;
    }

    .icon {
      transform: scale(1.1);
    }
  }

  &:active {
    transform: translateY(0);
  }

  .icon {
    width: 20px;
    height: 20px;
    transition: transform 0.3s ease;
  }

  .text-content {
    display: flex;
    flex-direction: column;
    flex: 1;

    .main-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 1.2;
    }

    .sub-text {
      font-size: 11px;
      opacity: 0.9;
      font-weight: 400;
      margin-bottom: 6px;
    }

    .store-badges {
      display: flex;
      gap: 6px;
      align-items: center;
      margin-top: 2px;

      .store-badge {
        height: 20px;
        width: auto;
        opacity: 0.95;
        transition: opacity 0.2s ease;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
`;

export const BrandSwitcher = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--primary);
  border-radius: 12px;
  margin: 12px;
  height: 56px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--primary_light);
  }

  .brand-header {
    display: flex;
    flex: 1;
    align-items: center;
    gap: 12px;
  }

  .brand-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--background);
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
  }

  .brand-icon img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  .brand-info {
    display: flex;
    flex-direction: column;
  }

  .brand {
    color: var(--grey_8);
    font-size: 10px;
    text-transform: uppercase;
    font-weight: 500;
  }

  .brand-name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 0;
    color: var(--grey_11);
  }

  .switch-button {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    .switch-button-icon {
      width: 20px;
    }
  }
`;
